// Popup.js
import React from 'react';
import './Popup.css';
import { useNavigate } from 'react-router-dom';

const PopupWindow = ({ message, type, onClose }) => {
    const navigate = useNavigate();

    // Popup type styling
    const popupClass =
        type == 'success'
            ? 'popup-success'
            : type == 'error'
                ? 'popup-error'
                : 'popup-warn';

    const iconClass =
        type == 'success'
            ? 'popup-success-icon'
            : type == 'error'
                ? 'popup-error-icon'
                : 'popup-warn-icon';

    const icon =
        type == 'success'
            ? 'fa-check'
            : type == 'error'
                ? 'fa-times'
                : 'fa-exclamation'; // ⚠️ for warning

    return (
        <div className="popup-overlay" onClick={onClose}>
            <div className={`popup-container ${popupClass}`} onClick={(e) => e.stopPropagation()}>
                {/* Icon above the message */}
                <div className={`popup-icon ${iconClass}`}>
                    <i className={`fas ${icon}`}></i>
                </div>

                {/* Message and Close Button */}
                <p>{message}</p>
                <button className="popup-button" onClick={onClose}>
                    OK
                </button>
            </div>
        </div>
    );
};

export default PopupWindow;
